import type { QueryClient } from "@tanstack/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import type React from "react";

interface QueryProviderProps {
	children: React.ReactNode;
	queryClient: QueryClient;
}

export function QueryProvider({ children, queryClient }: QueryProviderProps) {
	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	);
}
